import { render, staticRenderFns } from "./AddressItem.vue?vue&type=template&id=be65c6b2&scoped=true"
import script from "./AddressItem.vue?vue&type=script&lang=js"
export * from "./AddressItem.vue?vue&type=script&lang=js"
import style0 from "./AddressItem.vue?vue&type=style&index=0&id=be65c6b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be65c6b2",
  null
  
)

export default component.exports